import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const getBody = (mid: string, data: any) => {
  return {
    parentEntityIdentificationNumber: mid ?? '',
    type: '101',
    subType: data?.beneficiaryType ?? '',
    source: data?.source ?? '',
    status: data?.status ?? '',
    legalName: data?.name ?? '',
    businessProfile: {
      ownershipType: data?.ownershipType ?? '',
    },
    addressDetails: [
      {
        addressLine1: data?.addressLine1 ?? '',
        addressLine2: data?.addressLine2 ?? '',
        addressRole: data?.addressRole ?? '',
        phone1: data?.phone1 ?? '',
        emailAddr: data?.email ?? '',
        stateAbbrev: data?.stateAbbrev ?? '',
        countryCode: null,
        geoCode: data?.geoCode ?? '',
        pincode: data?.pincode,
        city: data?.city,
        latitude: data?.latitude,
        longitude: data?.longitude,
        state: data?.state,
        addressType: data?.addressType,
      },
    ],
    contactDetails: [
      {
        mobileNumber: data?.phone ?? '',
        emailId: data?.email ?? '',
      },
    ],
    settlementDetails: {
      accountNumber: data?.accountNumber ?? '',
      ifsCode: data?.ifsc ?? '',
      acctType: data?.acctType ?? '',
    },
  }
}

const addBeneficiary = (mid: string, beneficiaryDetails: any, tokens: any, userAccessToken: string) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.addBeneficiary,
    method: 'POST',
    config: sitConfig(tokens),
    headers: {
      Authorization: userAccessToken,
    },
    body: getBody(mid, beneficiaryDetails),
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { addBeneficiary }
